export default Object.freeze({
    MD: 'MD',
    DO: 'DO',
    DC: 'DC',
    DMD: 'DMD',
    DDS: 'DDS',
    OTHER: 'Other',
    PA: 'PA',
    NP: 'NP',
})
